export default function url_path(path: string):string {
  let domain = process.env.CLOUDFRONT_URL
  if (!domain) return path;
  if (!domain.match(/^(https?:|\/\/)/)) domain = `//${domain}`
  return domain + path;
}
